import * as React from 'react';
/**
 *
 * Original name: convert file
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=37194%3A10992
 *
 */
export const ConvertFilePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40 7.604H22v14h4v-10h14v7h7v24H26v-9h-4v13h29v-30a4.144 4.144 0 0 0-1.21-2.618l-2.572-2.556-2.494-2.478a4.636 4.636 0 0 0-3.268-1.348H40Zm-8.164 15.414 2.586 2.586H14v29h27v-4H18v-21h16.422l-2.586 2.586 2.828 2.828 7.414-7.414-7.414-7.414-2.828 2.828Z", fill: "currentColor" })));
